import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function ConfirmationInvitesModal({
    isOpen,
    onClose,
    onConfirm,
    processing = false
}) {

    return (
        <>

            <Modal isOpen={isOpen} toggle={onClose} centered>
                <ModalBody>
                    <div className='py-4 px-2'>
                        <h3 className='main_heading'>
                            Are you sure you want to {isOpen}?
                        </h3>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="main_button" onClick={() => onConfirm(isOpen)} disabled={processing}>Yes</button>
                    <button className="table_delete" onClick={onClose} disabled={processing}>Cancel</button>
                </ModalFooter>
            </Modal>


        </>
    );
}

export default ConfirmationInvitesModal;